import CustomerList from "./CustomerList";

export default CustomerList;
